import Link from '@material-ui/core/Link';

export default Link;
